import React, { Component } from 'react'

export default class Stats extends Component {
  render() {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '80px',
        padding: '40px 20px',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#4db8cd',
            margin: '0 0 8px 0'
          }}>
            10K+
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#666',
            margin: 0
          }}>
            Active Providers
          </p>
        </div>

        <div style={{
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#4db8cd',
            margin: '0 0 8px 0'
          }}>
            $500M+
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#666',
            margin: 0
          }}>
            Annual Transactions
          </p>
        </div>

        <div style={{
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#4db8cd',
            margin: '0 0 8px 0'
          }}>
            50+
          </h2>
          <p style={{
            fontSize: '14px',
            color: '#666',
            margin: 0
          }}>
            Countries
          </p>
        </div>
      </div>
    )
  }
}